import styled from "styled-components";

export const StyledSelectButton = styled.button<{ disabled: boolean }>`
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  border: 0;
  cursor: ${({ disabled }) => (disabled ? "none" : "pointer")};
  display: flex;
  gap: 16px;
  padding: 0;
  outline: none;
`;
